// MAIN ENTRY POINT
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// FIREBASE - Lazy loaded to avoid blocking initial load
import { initializeApp } from 'firebase/app';

// Your Firebase config
const firebaseConfig = {
     apiKey: "AIzaSyA224y1l8vtyrIOyNYZXV-l-FTP8IxpVQ0",
     authDomain: "createefi.firebaseapp.com",
     projectId: "createefi",
     storageBucket: "createefi.firebasestorage.app",
     messagingSenderId: "406760097789",
     appId: "1:406760097789:web:28f03972e157aded21bb94",
     measurementId: "G-R9SB620F46"
};

// Initialize Firebase app lazily after app bootstrap
let firebaseApp: any = null;

export function getFirebaseApp() {
     if (!firebaseApp) {
          firebaseApp = initializeApp(firebaseConfig);
     }
     return firebaseApp;
}

// ✅ Bootstrap Angular App
document.body.classList.add('loading');

bootstrapApplication(AppComponent, appConfig).then(() => {
     window.addEventListener('load', () => {
          document.body.classList.remove('loading');
          document.body.classList.add('loaded');
     });
});
